module.exports = __webpack_public_path__ + "img/twitter_akikun_oiwai.407f125b.png";